import React from 'react'
import AdminFooter from '../sections/AdminFooter'
import AdminHeader from '../sections/AdminHeader'
import AppLayout from './AppLayout'
import { NavLink } from 'react-router-dom'


function ErpLayout({children}) {
    return (
        
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className="list-group">
                            <NavLink to={"/product/dashboard"} className="list-group-item list-group-item-action">Products</NavLink>
                            <NavLink to={"/vendor/dashboard"} className="list-group-item list-group-item-action">Vendors</NavLink>
                            <NavLink to={"/po/dashboard"} className="list-group-item list-group-item-action">PO</NavLink>
                            <NavLink to={"/po/terms"} className="list-group-item list-group-item-action">PO Terms</NavLink>
                            <NavLink to={"/inventory/dashboard"} className="list-group-item list-group-item-action">Inventory</NavLink>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        {children}
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default ErpLayout